import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { EUserType } from 'src/app/domain/enum/user-type';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { UserService } from 'src/app/services/user.service';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { LoadingTask } from 'src/app/tools/ui/loading-task';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { environment } from 'src/environments/environment';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { AppConfig } from 'src/app/app.config';
const { version: appVersion } = require('../../../../package.json');

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrl: './nav-menu.component.scss',
    standalone: true,
    imports: [RouterLinkActive, RouterLink, MatIconModule, MatProgressBarModule, MatMenuModule, MatButtonModule]
})
export class NavMenuComponent implements OnInit {
    ENavigationRoute = ENavigationRoute;
    @Output() stateChanged = new EventEmitter<string>();
    isExpanded = false;
    Opacity = 0;
    AppName = `${this.config.getConfig('appName')}`;
    AppVersion: string = '';

    get EurofinsIconPath() {
        return this.CoreData.IsMobile ? 'favicon.ico' : 'assets/eurofins-logo-white.png';
    }

    get IsAdmin() {
        return this.CoreData.User?.Type === EUserType.Administrateur;
    }

    get IsTechnicien() {
        return this.CoreData.User?.Type === EUserType.Standard;
    }

    constructor(
        private config: AppConfig,
        private userService: UserService,
        protected oauthService: OAuthService,
        private router: Router,
        public loadingTask: LoadingTask,
        public CoreData: CoreData) {

    }

    ngOnInit() {
        this.AppVersion = appVersion;
        this.loadingTask.LoadingEmitter.subscribe(x => {
            if (x) {
                this.Opacity = 100;
            } else {
                this.Opacity = 0;
            }
        });
    }

    collapse() {
        this.isExpanded = false;
    }

    toggle() {
        this.isExpanded = !this.isExpanded;
        if (this.isExpanded) {
            this.stateChanged.emit('160px');
        } else {
            this.stateChanged.emit('80px');
        }
    }

    getSpecificFiles() {
        window.open(`${window.location.origin}/assets/juridique/MentionsLegales-CGU-RGPD.pdf`, '_blank');
    }

    IsLoggedIn() {
        return this.CoreData.IsLoggedIn;
    }

    async logout() {

        // await this.oauthService.revokeTokenAndLogout();

        // this.userService.logout().subscribe(x => {
        //     if (x) {
        //         this.oauthService.logOut();
        //         this.router.navigate([ENavigationRoute.Login]);
        //     }
        // })
        // this.EIMASService.logout().subscribe(x => {
        //     if (x) {
        //         this.oauthService.logOut();
        //         this.router.navigate([ENavigationRoute.Login]);
        //     }
        // })
        this.userService.logout().subscribe(x => {
            if (x) {
                this.oauthService.logOut();
                this.router.navigate([ENavigationRoute.Login]);
            }
        })
    }

    getUserProfileLabel() {
        if (!this.CoreData.User)
            return;
        return StringConverter.getUserTypeName(this.CoreData.User?.Type)
    }
}
